var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssue2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 18.4375C60.6369 18.4375 59.9375 17.7381 59.9375 16.875V15C59.9375 14.1369 60.6369 13.4375 61.5 13.4375C62.3631 13.4375 63.0625 14.1369 63.0625 15V16.875C63.0625 17.7381 62.3625 18.4375 61.5 18.4375Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6836 22.0537L68.1117 20.625V25.625",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 30.3125C60.6369 30.3125 59.9375 29.6131 59.9375 28.75V26.875C59.9375 26.0119 60.6369 25.3125 61.5 25.3125C62.3631 25.3125 63.0625 26.0119 63.0625 26.875V28.75C63.0625 29.6131 62.3625 30.3125 61.5 30.3125Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6836 33.9287L68.1117 32.5V37.5",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 42.1875C60.6369 42.1875 59.9375 41.4881 59.9375 40.625V38.75C59.9375 37.8869 60.6369 37.1875 61.5 37.1875C62.3631 37.1875 63.0625 37.8869 63.0625 38.75V40.625C63.0625 41.4881 62.3625 42.1875 61.5 42.1875Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6836 45.8038L68.1117 44.375V49.375",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 14.6875C44.3869 14.6875 43.6875 13.9881 43.6875 13.125V11.25C43.6875 10.3869 44.3869 9.6875 45.25 9.6875C46.1131 9.6875 46.8125 10.3869 46.8125 11.25V13.125C46.8125 13.9881 46.1125 14.6875 45.25 14.6875Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4336 18.3037L51.8617 16.875V21.875",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 26.5625C44.3869 26.5625 43.6875 25.8631 43.6875 25V23.125C43.6875 22.2619 44.3869 21.5625 45.25 21.5625C46.1131 21.5625 46.8125 22.2619 46.8125 23.125V25C46.8125 25.8631 46.1125 26.5625 45.25 26.5625Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4336 30.1787L51.8617 28.75V33.75",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.25 38.4375C44.3869 38.4375 43.6875 37.7381 43.6875 36.875V35C43.6875 34.1369 44.3869 33.4375 45.25 33.4375C46.1131 33.4375 46.8125 34.1369 46.8125 35V36.875C46.8125 37.7381 46.1125 38.4375 45.25 38.4375Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4336 42.0538L51.8617 40.625V45.625",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29 18.4375C28.1369 18.4375 27.4375 17.7381 27.4375 16.875V15C27.4375 14.1369 28.1369 13.4375 29 13.4375C29.8631 13.4375 30.5625 14.1369 30.5625 15V16.875C30.5625 17.7381 29.8625 18.4375 29 18.4375Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1836 22.0537L35.6117 20.625V25.625",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30.3125C28.1369 30.3125 27.4375 29.6131 27.4375 28.75V26.875C27.4375 26.0119 28.1369 25.3125 29 25.3125C29.8631 25.3125 30.5625 26.0119 30.5625 26.875V28.75C30.5625 29.6131 29.8625 30.3125 29 30.3125Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1836 33.9287L35.6117 32.5V37.5",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42.1875C28.1369 42.1875 27.4375 41.4881 27.4375 40.625V38.75C27.4375 37.8869 28.1369 37.1875 29 37.1875C29.8631 37.1875 30.5625 37.8869 30.5625 38.75V40.625C30.5625 41.4881 29.8625 42.1875 29 42.1875Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1836 45.8038L35.6117 44.375V49.375",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.6875C11.8869 14.6875 11.1875 13.9881 11.1875 13.125V11.25C11.1875 10.3869 11.8869 9.6875 12.75 9.6875C13.6131 9.6875 14.3125 10.3869 14.3125 11.25V13.125C14.3125 13.9881 13.6125 14.6875 12.75 14.6875Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9336 18.3037L19.3617 16.875V21.875",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 26.5625C11.8869 26.5625 11.1875 25.8631 11.1875 25V23.125C11.1875 22.2619 11.8869 21.5625 12.75 21.5625C13.6131 21.5625 14.3125 22.2619 14.3125 23.125V25C14.3125 25.8631 13.6125 26.5625 12.75 26.5625Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9336 30.1787L19.3617 28.75V33.75",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 38.4375C11.8869 38.4375 11.1875 37.7381 11.1875 36.875V35C11.1875 34.1369 11.8869 33.4375 12.75 33.4375C13.6131 33.4375 14.3125 34.1369 14.3125 35V36.875C14.3125 37.7381 13.6125 38.4375 12.75 38.4375Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9336 42.0538L19.3617 40.625V45.625",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.125 56.25H66.25L68.125 51.25H71.875",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 41.875H61.25",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 63.75H68.75L70.625 66.25",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 56.25H13.2266L11.3516 51.25H7.60156",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.957 48.3235C57.7214 48.0716 57.3264 48.0573 57.0733 48.2929C56.8214 48.5285 56.8076 48.9241 57.0426 49.1766C57.0545 49.1898 57.2358 49.386 57.5295 49.7229L58.1064 68.7623C57.8183 68.7716 57.5633 68.9691 57.5101 69.2641C57.4489 69.6041 57.6745 69.9279 58.0139 69.9898C58.0795 70.0016 58.7714 70.1216 59.7301 70.1216C61.0576 70.1216 62.897 69.8916 64.2995 68.8241C65.4439 67.9523 66.0995 66.6848 66.2476 65.0566C66.8901 57.9848 58.322 48.7148 57.957 48.3235Z",
    fill: "#EE4C7B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6016 41.875H18.2266",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7478 39.3752C28.7478 39.3752 26.2478 28.7502 35.6228 27.5002C39.5409 26.9777 42.4978 30.0002 42.4978 30.0002C42.4978 30.0002 46.8728 28.1252 49.9978 30.6252C52.4378 32.577 50.6228 38.7502 50.6228 38.7502",
    stroke: "black",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.2511 65.0554C66.1011 66.6867 65.4449 67.9492 64.3011 68.8242C62.9011 69.8929 61.0574 70.1242 59.7324 70.1242C58.9824 70.1242 58.4011 70.0492 58.1511 70.0117C59.1699 69.8617 60.2699 69.5179 61.1761 68.8242C62.3199 67.9492 62.9761 66.6867 63.1261 65.0554C63.5324 60.5242 60.1636 55.0804 57.5886 51.6617L57.5324 49.7242C57.2386 49.3867 57.0574 49.1867 57.0449 49.1742C56.8074 48.9242 56.8199 48.5304 57.0761 48.2929C57.3261 48.0554 57.7199 48.0679 57.9574 48.3242C58.3261 48.7117 66.8886 57.9867 66.2511 65.0554Z",
    fill: "#B22D59"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7491 63.75H10.7266L8.85156 66.25",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4559 40.1946C57.1121 44.4196 54.8559 47.1383 54.7371 47.2821C54.6121 47.4258 54.4371 47.5008 54.2621 47.5008C54.1184 47.5008 53.9746 47.4508 53.8559 47.3508C53.7121 47.2321 53.6434 47.0508 53.6434 46.8758H26.1434C26.1434 47.0508 26.0746 47.2321 25.9309 47.3508C25.6684 47.5758 25.2746 47.5446 25.0496 47.2821C24.9309 47.1446 22.9121 44.7071 22.4059 40.8696C22.3684 40.6133 22.3434 40.3571 22.3246 40.0883C22.2434 39.0446 22.2809 37.9133 22.4996 36.7071C23.6621 30.2633 29.9059 25.2008 34.9434 22.0883C38.0621 20.1571 41.9309 20.1696 45.0371 22.1196C49.9871 25.2321 56.1309 30.2821 57.2871 36.7071C57.5121 37.9571 57.5434 39.1258 57.4559 40.1946Z",
    fill: "#8C224B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 33.125H30.625C30.2794 33.125 30 33.4044 30 33.75V45.8681C30 49.1806 32.695 51.875 36.0069 51.875H43.3675C46.68 51.875 49.3744 49.18 49.3744 45.8681V33.75C49.375 33.4044 49.0956 33.125 48.75 33.125Z",
    fill: "#FFC7BE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3734 33.75V45.8687C49.3734 49.1812 46.6797 51.875 43.3672 51.875H40.2422C43.5547 51.875 46.2484 49.1812 46.2484 45.8687V33.75C46.2484 33.4062 45.9672 33.125 45.6234 33.125H48.7484C49.0922 33.125 49.3734 33.4062 49.3734 33.75Z",
    fill: "#E59991"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3644 49.1764C22.5994 48.9239 22.5856 48.5283 22.3338 48.2926C22.0806 48.0576 21.6863 48.0714 21.45 48.3233C21.085 48.7145 12.5169 57.9845 13.1594 65.0564C13.3075 66.6845 13.9631 67.9526 15.1075 68.8239C16.5094 69.8914 18.3494 70.1214 19.6769 70.1214C20.6356 70.1214 21.3275 70.0014 21.3931 69.9895C21.7325 69.9276 21.9575 69.6039 21.8969 69.2639C21.8438 68.9689 21.5906 68.7726 21.3013 68.7626L21.8781 49.7226C22.1713 49.3851 22.3525 49.1889 22.3644 49.1764Z",
    fill: "#EE4C7B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4994 61.25C57.4994 61.25 59.9994 60 63.1244 62.5M21.9062 61.25C21.9062 61.25 19.4062 60 16.2812 62.5",
    stroke: "#8C0036",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3999 38.2872C51.3187 38.5997 51.2562 38.8247 51.2249 38.9247C51.1249 39.2559 50.7749 39.4497 50.4499 39.3497C50.1937 39.2747 46.5812 41.0809 41.8874 36.3059C41.6812 36.0934 41.4624 35.8684 41.2499 35.6247C41.2499 35.6247 41.0562 35.8809 40.6624 36.2622C39.3187 37.5747 35.6499 40.3372 29.3624 39.3559C29.0749 39.3122 28.1249 39.3747 28.1249 39.3747C28.1212 39.3566 28.0255 38.9303 27.9749 38.5497C27.7312 36.8184 27.5187 33.1184 29.4687 30.2934C30.7812 28.3934 32.8249 27.2434 35.5437 26.8809C39.0187 26.4184 41.7499 28.4934 42.6437 29.2747C43.8437 28.8559 47.5374 27.8559 50.3874 30.1372C52.6749 31.9622 51.8249 36.5372 51.3999 38.2872Z",
    fill: "#915524"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6481 66.875H22.7269C21.5681 66.875 20.625 67.8181 20.625 68.9769V69.1475C20.625 70.3063 21.5681 71.2494 22.7269 71.2494H56.6475C57.8063 71.2494 58.7494 70.3063 58.7494 69.1475V68.9769C58.75 67.8181 57.8069 66.875 56.6481 66.875Z",
    fill: "#1578AF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4209 38.75C28.1903 38.75 27.2266 39.9856 27.2266 41.5625C27.2266 43.08 29.2353 45 30.4666 45C31.2509 45 31.2509 44.4275 31.2509 41.25C31.2509 39.1838 30.2559 38.75 29.4209 38.75Z",
    fill: "#FFC7BE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5563 46.25H23.8188C22.4025 46.25 21.25 47.4025 21.25 48.8188V67.5C21.25 67.8456 21.5294 68.125 21.875 68.125H57.5C57.8456 68.125 58.125 67.8456 58.125 67.5V48.8188C58.125 47.4025 56.9725 46.25 55.5563 46.25Z",
    fill: "#004573"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.7484 68.975V69.15C58.7484 70.3062 57.8047 71.25 56.6484 71.25H52.2734C53.4297 71.25 54.3734 70.3062 54.3734 69.15V68.975C54.3734 67.8188 53.4297 66.875 52.2734 66.875H56.6484C57.8047 66.875 58.7484 67.8188 58.7484 68.975Z",
    fill: "#004573"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50.625C36.8981 50.625 34.375 53.1481 34.375 56.25C34.375 57.8606 35.0544 59.3706 36.25 60.4388V63.125C36.25 63.4706 36.5294 63.75 36.875 63.75H43.125C43.4706 63.75 43.75 63.4706 43.75 63.125V60.4388C44.9456 59.3706 45.625 57.8606 45.625 56.25C45.625 53.1481 43.1019 50.625 40 50.625Z",
    fill: "#D0FAFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M58.125 48.8188V67.5C58.125 67.8438 57.8438 68.125 57.5 68.125H21.875C21.5312 68.125 21.25 67.8438 21.25 67.5V65.625H54.375C54.7188 65.625 55 65.3438 55 65V46.3188C55 46.2938 55 46.275 54.9937 46.25H55.5563C56.975 46.25 58.125 47.4 58.125 48.8188Z",
    fill: "#033551"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M45.625 56.2504C45.625 57.8629 44.9438 59.3691 43.75 60.4379V63.1254C43.75 63.4691 43.4688 63.7504 43.125 63.7504H36.875C36.5312 63.7504 36.25 63.4691 36.25 63.1254V61.8754H40.625C40.9688 61.8754 41.25 61.5941 41.25 61.2504V58.5629C42.4437 57.4941 43.125 55.9879 43.125 54.3754C43.125 53.1066 42.7 51.9379 41.9875 50.9941C44.1125 51.7941 45.625 53.8504 45.625 56.2504Z",
    fill: "#ACDEE2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 62.5V61.25",
    stroke: "#60CFFF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 62.5V61.25",
    stroke: "#60CFFF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 58.125C42.7053 58.125 43.125 57.7053 43.125 57.1875C43.125 56.6697 42.7053 56.25 42.1875 56.25C41.6697 56.25 41.25 56.6697 41.25 57.1875C41.25 57.7053 41.6697 58.125 42.1875 58.125Z",
    stroke: "#60CFFF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 58.125C38.8154 58.125 39.375 57.5654 39.375 56.875C39.375 56.1846 38.8154 55.625 38.125 55.625C37.4346 55.625 36.875 56.1846 36.875 56.875C36.875 57.5654 37.4346 58.125 38.125 58.125Z",
    stroke: "#60CFFF",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 53.125H51.875",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 56.875H50",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 60H48.125",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M50.307 38.75C49.077 38.75 48.1133 39.9856 48.1133 41.5625C48.1133 42.7731 48.1264 44.38 48.1264 44.38C48.1295 44.7238 48.4083 45 48.7514 45C49.8689 45 52.5014 43.2019 52.5014 41.5625C52.5014 39.9856 51.5377 38.75 50.307 38.75Z",
    fill: "#E59991"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 41.875L49.375 39.375",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 41.875L29.375 38.75",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 60H28.125",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 45C37.1783 45 38.4375 43.7408 38.4375 42.1875C38.4375 40.6342 37.1783 39.375 35.625 39.375C34.0717 39.375 32.8125 40.6342 32.8125 42.1875C32.8125 43.7408 34.0717 45 35.625 45Z",
    fill: "#004573"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M44.375 45C45.9283 45 47.1875 43.7408 47.1875 42.1875C47.1875 40.6342 45.9283 39.375 44.375 39.375C42.8217 39.375 41.5625 40.6342 41.5625 42.1875C41.5625 43.7408 42.8217 45 44.375 45Z",
    fill: "#004573"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 56.25H30",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M47.1867 42.1887C47.1867 43.7387 45.9242 45.0012 44.3742 45.0012C42.8242 45.0012 41.5617 43.7387 41.5617 42.1887C41.5617 42.1512 41.5617 42.1199 41.568 42.0824C42.0805 42.7199 42.868 43.1262 43.7492 43.1262C45.2617 43.1262 46.5055 41.9199 46.5555 40.4199C46.9555 40.9074 47.1867 41.5199 47.1867 42.1887ZM38.4367 42.1887C38.4367 43.7387 37.1742 45.0012 35.6242 45.0012C34.243 45.0012 33.0867 43.9949 32.8555 42.6762C33.293 42.9637 33.8117 43.1262 34.3742 43.1262C35.9242 43.1262 37.1867 41.8637 37.1867 40.3137C37.1867 40.1449 37.1742 39.9824 37.143 39.8262C37.9242 40.3262 38.4367 41.2012 38.4367 42.1887Z",
    fill: "#033551"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 39.375C34.075 39.375 32.8125 40.6375 32.8125 42.1875C32.8125 42.8563 33.0437 43.4688 33.4437 43.9563C33.47 43.1631 33.8362 42.4587 34.3931 41.965C34.4381 42.2656 34.6869 42.5 35 42.5C35.345 42.5 35.625 42.22 35.625 41.875C35.625 41.68 35.53 41.5125 35.39 41.3981C35.6631 41.3094 35.9488 41.25 36.25 41.25C37.1312 41.25 37.9188 41.6562 38.4313 42.2937C38.4375 42.2562 38.4375 42.225 38.4375 42.1875C38.4375 40.6375 37.175 39.375 35.625 39.375ZM47.1438 41.7C46.9125 40.3813 45.7563 39.375 44.375 39.375C42.825 39.375 41.5625 40.6375 41.5625 42.1875C41.5625 43.175 42.075 44.05 42.8562 44.55C42.825 44.3937 42.8125 44.2312 42.8125 44.0625C42.8125 43.2262 43.1869 42.4825 43.7687 41.9669C43.8144 42.2663 44.0625 42.5 44.375 42.5C44.72 42.5 45 42.22 45 41.875C45 41.68 44.9056 41.5131 44.7656 41.3987C45.0381 41.31 45.3237 41.25 45.625 41.25C46.1875 41.25 46.7063 41.4125 47.1438 41.7Z",
    fill: "#52B1DB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 53.125H31.875",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3999 38.2872C48.7687 37.2684 45.5124 36.5059 41.8874 36.3059C41.6812 36.0934 41.4624 35.8684 41.2499 35.6247C41.2499 35.6247 41.0562 35.8809 40.6624 36.2622C40.4437 36.2497 40.2249 36.2497 39.9999 36.2497C35.3124 36.2497 31.1249 37.2309 27.9749 38.5497C27.7312 36.8184 27.5187 33.1184 29.4687 30.2934C30.7812 28.3934 32.8249 27.2434 35.5437 26.8809C39.0187 26.4184 41.7499 28.4934 42.6437 29.2747C43.8437 28.8559 47.5374 27.8559 50.3874 30.1372C52.6749 31.9622 51.8249 36.5372 51.3999 38.2872Z",
    fill: "#5E3312"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M38.125 42.9109C38.3612 42.0978 39.1081 41.5078 40 41.5078C40.8919 41.5078 41.6388 42.0978 41.875 42.9109",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4375 53.125C74.6456 53.125 75.625 52.1456 75.625 50.9375C75.625 49.7294 74.6456 48.75 73.4375 48.75C72.2294 48.75 71.25 49.7294 71.25 50.9375C71.25 52.1456 72.2294 53.125 73.4375 53.125Z",
    fill: "#FFBD5B"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8125 43.75C64.0206 43.75 65 42.7706 65 41.5625C65 40.3544 64.0206 39.375 62.8125 39.375C61.6044 39.375 60.625 40.3544 60.625 41.5625C60.625 42.7706 61.6044 43.75 62.8125 43.75Z",
    fill: "#00FF51"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5625 70C72.7706 70 73.75 69.0206 73.75 67.8125C73.75 66.6044 72.7706 65.625 71.5625 65.625C70.3544 65.625 69.375 66.6044 69.375 67.8125C69.375 69.0206 70.3544 70 71.5625 70Z",
    fill: "#EE4C7B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03906 53.125C7.24718 53.125 8.22656 52.1456 8.22656 50.9375C8.22656 49.7294 7.24718 48.75 6.03906 48.75C4.83094 48.75 3.85156 49.7294 3.85156 50.9375C3.85156 52.1456 4.83094 53.125 6.03906 53.125Z",
    fill: "#004573"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 43.75C17.8722 43.75 18.8516 42.7706 18.8516 41.5625C18.8516 40.3544 17.8722 39.375 16.6641 39.375C15.4559 39.375 14.4766 40.3544 14.4766 41.5625C14.4766 42.7706 15.4559 43.75 16.6641 43.75Z",
    fill: "#EE4C7B"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91406 70C9.12219 70 10.1016 69.0206 10.1016 67.8125C10.1016 66.6044 9.12219 65.625 7.91406 65.625C6.70594 65.625 5.72656 66.6044 5.72656 67.8125C5.72656 69.0206 6.70594 70 7.91406 70Z",
    fill: "#00FF51"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4559 40.1936L57.3871 40.7874C57.0371 40.4624 56.6621 40.0624 56.5059 39.9186C56.4871 39.8999 56.4746 39.8874 56.4621 39.8749C56.0309 39.5061 55.5246 39.1374 54.9496 38.7749C54.5246 38.5061 54.0621 38.2499 53.5621 37.9999C53.3996 37.9124 53.2309 37.8249 53.0559 37.7499C49.7996 36.1999 45.2059 34.9999 39.9996 34.9999C33.0496 34.9999 27.1934 37.1561 24.1871 39.3686C23.8746 39.5936 23.5934 39.8249 23.3496 40.0499C23.2746 40.1124 22.7996 40.5436 22.4059 40.8686C22.3684 40.6124 22.3434 40.3561 22.3246 40.0874C22.2434 39.0436 22.2809 37.9124 22.4996 36.7061C23.6621 30.2624 29.9059 25.1999 34.9434 22.0874C35.8371 21.5311 36.7934 21.1374 37.7746 20.9124C37.9559 20.8686 38.1371 20.8311 38.3246 20.7999C38.4746 20.7686 38.6371 20.7436 38.7934 20.7249C38.9246 20.7061 39.0559 20.6936 39.1871 20.6874C41.1996 20.5124 43.2434 20.9936 45.0371 22.1186C49.9871 25.2311 56.1309 30.2811 57.2871 36.7061C57.5121 37.9561 57.5434 39.1249 57.4559 40.1936Z",
    fill: "#EE4C7B"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4375 52.5C74.3004 52.5 75 51.8004 75 50.9375C75 50.0746 74.3004 49.375 73.4375 49.375C72.5746 49.375 71.875 50.0746 71.875 50.9375C71.875 51.8004 72.5746 52.5 73.4375 52.5Z",
    stroke: "#FA7F00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8125 43.125C63.6754 43.125 64.375 42.4254 64.375 41.5625C64.375 40.6996 63.6754 40 62.8125 40C61.9496 40 61.25 40.6996 61.25 41.5625C61.25 42.4254 61.9496 43.125 62.8125 43.125Z",
    stroke: "#068C49",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5625 69.375C72.4254 69.375 73.125 68.6754 73.125 67.8125C73.125 66.9496 72.4254 66.25 71.5625 66.25C70.6996 66.25 70 66.9496 70 67.8125C70 68.6754 70.6996 69.375 71.5625 69.375Z",
    stroke: "#8C0036",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03906 52.5C6.90201 52.5 7.60156 51.8004 7.60156 50.9375C7.60156 50.0746 6.90201 49.375 6.03906 49.375C5.17612 49.375 4.47656 50.0746 4.47656 50.9375C4.47656 51.8004 5.17612 52.5 6.03906 52.5Z",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 43.125C17.527 43.125 18.2266 42.4254 18.2266 41.5625C18.2266 40.6996 17.527 40 16.6641 40C15.8011 40 15.1016 40.6996 15.1016 41.5625C15.1016 42.4254 15.8011 43.125 16.6641 43.125Z",
    stroke: "#8C0036",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91406 69.375C8.77701 69.375 9.47656 68.6754 9.47656 67.8125C9.47656 66.9496 8.77701 66.25 7.91406 66.25C7.05112 66.25 6.35156 66.9496 6.35156 67.8125C6.35156 68.6754 7.05112 69.375 7.91406 69.375Z",
    stroke: "#068C49",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 70.625H66.25",
    stroke: "#033049",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M57.4586 40.1936L57.3898 40.7874C57.0398 40.4624 56.6648 40.0624 56.5086 39.9186C56.4898 39.8999 56.4773 39.8874 56.4648 39.8749C56.0336 39.5061 55.5273 39.1374 54.9523 38.7749C54.5273 38.5061 54.0648 38.2499 53.5648 37.9999C53.4023 37.9124 53.2336 37.8311 53.0586 37.7499C53.0273 37.4061 52.9773 37.0624 52.9148 36.7061C51.7586 30.2811 45.6148 25.2311 40.6648 22.1186C39.7523 21.5499 38.7773 21.1436 37.7773 20.9124C37.9586 20.8686 38.1398 20.8311 38.3273 20.7999C38.4773 20.7686 38.6398 20.7436 38.7961 20.7249C38.9273 20.7061 39.0586 20.6936 39.1898 20.6874C41.2023 20.5124 43.2461 20.9936 45.0398 22.1186C49.9898 25.2311 56.1336 30.2811 57.2898 36.7061C57.5148 37.9561 57.5461 39.1249 57.4586 40.1936Z",
    fill: "#B22D59"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5697 62.2695C76.7759 62.2695 76.7784 60.3945 75.5697 60.3945C74.3634 60.3945 74.3609 62.2695 75.5697 62.2695Z",
    fill: "#8C0036"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue2);
export default __webpack_public_path__ + "static/media/issue-2.cc48b2cb3c3256c564e98833757be540.svg";
export { ForwardRef as ReactComponent };